import React from 'react';
import clsx from 'clsx';
import { Menu, ClickAwayListener } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { MyMenuItem } from '../../styling/Styles';

/**
 * @param {boolean} props.needSave - shows if current project is saved/unsaved
 * @param {setState} props.setAboutToViewPageFlow - hook method that updates aboutToViewPageFlow, this variable is used inside BuildUpsExitPopUpWindow pop up to navigate to view_page_flow
 * @param {setState} props.setAboutToViewProjectFlow - hook method that updates aboutToViewProjectFlow, this variable is used inside BuildUpsExitPopUpWindow pop up το navihate to view_project_flow 
 * @param {setState} props.setAlertExitBuildUps - hook method that updates alertExitBuildUps, this variable opens/close BuildUpsExitPopUpWindow pop up
 * @param {method} props.savedPageClicked - method that saves project's page
 * @param {boolean} props.enableBreadCrumb - shows if onclick functions in breadcrumb are enabled/disabled  
 * @returns component with a dropdown menu that opens options to nagiate to view  page's 'data flow' and view project's 'data flow' 
 */
const ViewDataFlow = (props) => {
  const {
    needSave,
    setAboutToViewPageFlow,
    setAboutToViewProjectFlow,
    setAlertExitBuildUps,
    savedPageClicked,
    enableBreadCrumb
  } = props;

  const flowOptions = ['View page data flow', 'View project data flow'];
  const [anchorEl3, setAnchorEl3] = React.useState(); // anchor element of dropdown component
  const [stateFlowOptions, setStateFlowOptions] = React.useState(false); // opens/closes dropdown menu 

  const navigate = useNavigate(); // initialize navigation 

  // Opens dropdown menu
  const openDisplayFlowOptions = (event) => {
    setAnchorEl3(event.currentTarget);
    setStateFlowOptions(true);
  };

  // Closes dropdown menu
  const closeDisplayFlowOptions = () => {
    setStateFlowOptions(false);
    setAnchorEl3(null);
  };

  // Method that is called when 'view page data flow' option is pressed
  const changeToViewPageFlow = () => {
    // If page is unsaved and setAboutToViewPageFlow is given as property then BuildUpsExitPopUpWindow pop up opens and aboutToViewPageFlow variable is set to true
    if (setAboutToViewPageFlow !== undefined && needSave() === true) {
      setAboutToViewPageFlow(true);
      setAlertExitBuildUps(true);
    } 
    // setAboutToViewPageFlow is not given as attribute. This happens in every page that uses this component except inside build_apps
    else {
      // save before leaving page. This may needs to removed 
      if (setAboutToViewPageFlow !== undefined) {
        savedPageClicked();
      }
      navigate('/view_page_flow'); // navigate to page view_page_flow
    }
  };

  // Method that is called when 'view project data flow' option is pressed
  const changeToViewProjectFlow = () => {
    // If page is unsaved and setAboutToViewProjectFlow is given as property then BuildUpsExitPopUpWindow pop up opens and aboutToViewProjectFlow variable is set to true
    if (setAboutToViewProjectFlow !== undefined && needSave() === true) {
      setAboutToViewProjectFlow(true);
      setAlertExitBuildUps(true);
    }
    // setAboutToViewProjectFlow is not given as attribute. This happens in every page that uses this component except inside build_apps
    else {
      // save before leaving page. This may needs to removed 
      if (setAboutToViewProjectFlow !== undefined) {
        savedPageClicked();
      }
      navigate('/view_project_flow'); // navigate to page view_project_flow 
    }
  };

  // This method is called when option of dropdown menu is pressed
  const selectFlowOption = (index) => {
    if (index === 0) {
      changeToViewPageFlow();
    } else {
      changeToViewProjectFlow();
    }
  };

  return (
      enableBreadCrumb === false ? (
        <div
          style={{ marginRight: '1vw', marginTop: '0.5vw', transform: 'translate(-50%, 0)' }}
          className={clsx('fas fa-project-diagram fa-project-diagram2')}
        />
      ) : (
        <div
          data-tooltip="View data flow"
          data-tooltip-pos="bottom"
          style={{ marginRight: '1vw', marginTop: '0.5vw' }}
          onClick={(event) => openDisplayFlowOptions(event)}
          className={clsx('fas fa-project-diagram', 'teamSelector')}
          aria-hidden="true"
        >
          {stateFlowOptions === false ? (
            <span />
          ) : (
            <ClickAwayListener onClickAway={closeDisplayFlowOptions}>
              <span />
            </ClickAwayListener>
          )}
          <Menu
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            anchorEl={anchorEl3}
            keepMounted
            open={stateFlowOptions}
            MenuListProps={{ onMouseLeave: closeDisplayFlowOptions }}
          >
            {flowOptions.map((option, index) => (
              <MyMenuItem key={option} onClick={() => selectFlowOption(index)}>
                {option}
              </MyMenuItem>
            ))}
          </Menu>
        </div>
      )
  )
};

export default ViewDataFlow;
